import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

type AdjustmentType = 'PERCENTAGE' | 'AMOUNT';

interface AdjustmentTypeToggleProps {
  value: AdjustmentType;
  disabled?: boolean;
  onChange: (type: AdjustmentType) => void;
  ariaLabel: string;
}

const toggleGroupSx = {
  flexShrink: 0,
  '& .MuiToggleButton-root': {
    py: 0.35,
    px: 1,
    minWidth: 40,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
  },
};

const AdjustmentTypeToggle: React.FC<AdjustmentTypeToggleProps> = ({
  value,
  disabled,
  onChange,
  ariaLabel,
}) => {
  const selected = value === 'PERCENTAGE' ? 'PERCENTAGE' : 'AMOUNT';

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      color="primary"
      value={selected}
      disabled={disabled}
      aria-label={ariaLabel}
      sx={toggleGroupSx}
      onChange={(_event, next: AdjustmentType | null) => {
        if (next !== 'PERCENTAGE' && next !== 'AMOUNT') {
          return;
        }
        onChange(next);
      }}
    >
      <ToggleButton value="AMOUNT" aria-label="Monto">
        Bs
      </ToggleButton>
      <ToggleButton value="PERCENTAGE" aria-label="Porcentaje">
        %
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export type { AdjustmentType };
export default AdjustmentTypeToggle;
